<template>
    <section style="margin: 0px !important">
      <div id="backBox"></div>
      <Navbar />

      <!-- 2 columns for main page -->
      <div class="mainFlex">
        <!-- FIRST COLUMN -->
        <div class="flexLeft">
          <Groups />
        </div>

        <!-- MAIN BLOCK -->
        <div class="uploadBox">
          <div class="topBar">
            <p class="barText">{{groupName}} Documents</p>
          </div>
          <div class="documentBox">
            <div class="documentRow">
              <AddFolder />
              <div v-for="(folder, index) in folders" :key="index">
                <Folder :folder="folder" />
                <div v-if="folder.showDetails">
                  <FolderDetails :folder="folder"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>

<script>
import { mapState } from "vuex";
import Groups from "@/components/Groups";
import Navbar from "@/components/Navbar";
import AddFolder from "@/components/upload/AddFolder";
import Folder from '@/components/upload/Folder'
import FolderDetails from '@/components/upload/FolderDetails';
import db from "@/db";


export default {
  data: () => ({
    folders: [],
  }),
   mounted() {
    this.fetchFolders();
  },
  unmounted(){
    this.setIsAddingFolder();
  },

  components: {
      Groups,
      Navbar,
      AddFolder,
      Folder,
      FolderDetails,
    },
  computed: {
    ...mapState("messageBoard", ["groupId","groupName"]),
    ...mapState("upload", ["isAddingFolder", "isShowingDetails", "game"]),
  },
  methods:{
      fetchFolders(){
        db.collection("notebooks")
        .where("group_id", "==", this.groupId)
        .orderBy("createDate", "desc")
        .onSnapshot((notebooks) => {
          notebooks.docChanges().forEach((notebook) => {
            if (notebook.type === "added") {
              let folder = this.createNotebook(notebook.doc.data());
              this.folders.push(folder);
            }
          });
        });
      },
      createNotebook(notebook){
        return {
          title: notebook.title,
          documents: notebook.documents,
          group_id: notebook.groupId,
          createDate: notebook.createDate,
          color: notebook.color,
          showDetails: false,
        };
      },
      setIsAddingFolder(){
        this.$store.commit("upload/setIsAddingFolder", false);
      },
      toggleDetails(folder){
        folder.showDetails = true;
      },

  }
}
</script>

<style src="@/styles/Upload.css"></style>